import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Informazioni Centro */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center">
                <span className="text-white font-bold">CP</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">Centro Papa</h3>
                <p className="text-sm text-slate-300">Riabilitazione Motoria</p>
              </div>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              Centro specializzato in riabilitazione motoria, fisioterapia e ginnastica posturale. 
              Professionalità e competenza al servizio del tuo benessere.
            </p>
            <div className="flex space-x-4">
              <Facebook className="h-5 w-5 text-slate-400 hover:text-primary cursor-pointer smooth-transition" />
              <Instagram className="h-5 w-5 text-slate-400 hover:text-primary cursor-pointer smooth-transition" />
              <Linkedin className="h-5 w-5 text-slate-400 hover:text-primary cursor-pointer smooth-transition" />
            </div>
          </div>

          {/* Link Rapidi */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Link Rapidi</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-slate-300 hover:text-primary smooth-transition text-sm">
                Home
              </Link>
              <Link to="/servizi" className="block text-slate-300 hover:text-primary smooth-transition text-sm">
                Servizi
              </Link>
              <Link to="/chi-siamo" className="block text-slate-300 hover:text-primary smooth-transition text-sm">
                Chi Siamo
              </Link>
              <Link to="/contatti" className="block text-slate-300 hover:text-primary smooth-transition text-sm">
                Contatti
              </Link>
            </div>
          </div>

          {/* Servizi */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">I Nostri Servizi</h4>
            <div className="space-y-2 text-sm text-slate-300">
              <p>Fisioterapia</p>
              <p>Riabilitazione Motoria</p>
              <p>Ginnastica Posturale</p>
              <p>Terapia Manuale</p>
              <p>Rieducazione Funzionale</p>
              <p>Specialista Età Evolutiva</p>
            </div>
          </div>

          {/* Contatti */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contatti</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-primary flex-shrink-0" />
                <span className="text-sm text-slate-300">+39 347 5391433</span>
              </div>
              <a href="mailto:info@riabilitazionemotoriapapa.it" className="flex items-center space-x-3 hover:text-accent smooth-transition">
                <Mail className="h-4 w-4 text-primary flex-shrink-0" />
                <span className="text-sm text-slate-300 hover:text-accent">info@riabilitazionemotoriapapa.it</span>
              </a>
              <div className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                <span className="text-sm text-slate-300">
                  Via Nazionale Terme, 191<br />
                  98050 Terme Vigliatore (ME)
                </span>
              </div>
              <div className="flex items-start space-x-3">
                <Clock className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
                <div className="text-sm text-slate-300">
                  <p>Lun-Ven: 8:00-19:00</p>
                  <p>Sabato: 8:00-13:00</p>
                  <p>Domenica: Chiuso</p>
                </div>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Seguici</h4>
            <div className="flex space-x-4">
              <a 
                href="https://g.co/kgs/VAvHRR" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-primary smooth-transition group"
                title="Google My Business"
              >
                <svg className="h-5 w-5 text-slate-300 group-hover:text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 14.634c-.47 0-.799-.34-.799-.799s.329-.799.799-.799.799.34.799.799-.329.799-.799.799zm3.648-3.648c0-2.012-1.636-3.648-3.648-3.648S8.369 8.974 8.369 10.986s1.636 3.648 3.648 3.648 3.648-1.636 3.648-3.648zm2.183 0c0 3.218-2.613 5.831-5.831 5.831S6.186 14.204 6.186 10.986s2.613-5.831 5.831-5.831 5.831 2.613 5.831 5.831z"/>
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/riabilitazionemotoriapapa" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-pink-600 smooth-transition group"
                title="Instagram"
              >
                <svg className="h-5 w-5 text-slate-300 group-hover:text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a 
                href="https://www.linkedin.com/in/peppino-salvatore-papa-021b37231" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-blue-600 smooth-transition group"
                title="LinkedIn"
              >
                <svg className="h-5 w-5 text-slate-300 group-hover:text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
            <div className="text-sm text-slate-400">
              <p>Seguici sui social per aggiornamenti,</p>
              <p>consigli e novità dal centro</p>
            </div>
          </div>
        </div>

        {/* Metodi di Pagamento */}
        <div className="border-t border-slate-700 mt-12 pt-8">
          <div className="text-center mb-6">
            <h4 className="text-lg font-semibold mb-4">Metodi di Pagamento Accettati</h4>
            <div className="flex justify-center">
              <img 
                src="/images/IMG_3563.jpeg" 
                alt="Metodi di pagamento: VISA, Mastercard, American Express, Maestro, Discover, JCB, UnionPay" 
                className="max-w-full h-auto max-h-16 opacity-80 hover:opacity-100 smooth-transition"
              />
            </div>
            <p className="text-xs text-slate-400 mt-2">
              Pagamenti sicuri tramite SumUp | Contanti | Bonifico | POS
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-slate-400">
              <p>© 2024 Dott. Peppino Salvatore Papa - Centro di Riabilitazione Motoria</p>
              <p className="mt-1">
                Terapista - TNPEE | Tecnico Chinesiologo | Tecnico Sportivo | Trainer Fitness
              </p>
              <p className="mt-1">
                P.IVA: 02904900830 | C.F.: PPAPPN73E08M210N
              </p>
              <p className="mt-1">
                Iscr. Albo TSRM-PSTRP n. ME 67 | Iscr. Albo Reg. Naz. C.S.A.In | Iscr. Albo ATS
              </p>
            </div>
            <div className="flex space-x-6 text-sm text-slate-400">
              <a href="#" className="hover:text-primary smooth-transition">Privacy Policy</a>
              <a href="#" className="hover:text-primary smooth-transition">Cookie Policy</a>
              <a href="#" className="hover:text-primary smooth-transition">Termini di Servizio</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;